export function matchesMedia(query) {
  return typeof window !== 'undefined' && window.matchMedia(query).matches;
}

export function viewportBox() {
  const vv = typeof window !== 'undefined' ? window.visualViewport : null;
  return {
    width: vv?.width ?? window.innerWidth,
    height: vv?.height ?? window.innerHeight,
    offsetTop: vv?.offsetTop ?? 0,
    offsetLeft: vv?.offsetLeft ?? 0,
  };
}

export function setImportant(el, prop, value) {
  if (el.style.getPropertyValue(prop) === value) return false;
  el.style.setProperty(prop, value, 'important');
  return true;
}

export function setImportantStyles(el, styles) {
  Object.entries(styles).forEach(([prop, value]) => setImportant(el, prop, value));
}

export function revealEl(el) {
  if (!el) return;
  el.style.removeProperty('display');
  el.style.removeProperty('visibility');
  el.style.removeProperty('opacity');
  el.removeAttribute('aria-hidden');
}

export function buttonLabel(el) {
  if (!el) return '';
  return [
    el.getAttribute('aria-label'),
    el.getAttribute('data-text'),
    el.getAttribute('title'),
    el.getAttribute('aria-title'),
    el.textContent,
  ]
    .join(' ')
    .trim();
}

export function isTawkHost(el) {
  if (!el || el.nodeType !== 1) return false;
  let iframeChildren = 0;
  for (const child of el.children) {
    if (child.nodeName === 'IFRAME') iframeChildren += 1;
  }
  return iframeChildren >= 2;
}

export function isTawkIframe(iframe) {
  if (!iframe || iframe.nodeName !== 'IFRAME') return false;
  if (iframe.dataset.tawkMobileLayout === '1') return true;
  const title = String(iframe.title || '').toLowerCase();
  const src = String(iframe.src || '');
  if (title.includes('chat') || src.includes('tawk.to')) return true;
  return isTawkHost(iframe.parentElement);
}

export function forEachTawkIframe(callback) {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('iframe').forEach((iframe) => {
    if (isTawkIframe(iframe)) callback(iframe);
  });
}
